import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralEarnedCreditIA = function BrandReferralEarnedCreditIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_EARNED_CREDIT_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_EARNED_CREDIT_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_EARNED_CREDIT_TITLE = function BRAND_REFERRALS_EARNED_CREDIT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "eFoMBv",
    defaultMessage: [{
      "type": 0,
      "value": "Zo verdien je tegoed aan merkdoorverwijzingen"
    }]
  });
};
var BRAND_REFERRALS_EARNED_CREDIT_DESCRIPTION = function BRAND_REFERRALS_EARNED_CREDIT_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "b9gLY6",
    defaultMessage: [{
      "type": 0,
      "value": "Om tegoed te verdienen moet het merk jouw doorverwijslink gebruiken of jou als hun doorverwijzer selecteren wanneer ze zich registreren op Faire. Het tegoedbedrag is afhankelijk van de actieve promotie wanneer je de doorverwijzing indient. Controleer je ‘Verdiend tegoed’ voor een specifiek merk door naar ‘Merken doorverwijzen’ te gaan in ‘Account’ en het tabblad ‘Geregistreerd’ te selecteren. Als je de berichten ‘Heeft je link niet gebruikt’ of ‘Al actief’ ziet, kom je niet in aanmerking voor doorverwijzingstegoed."
    }]
  });
};